import { useContext } from 'react'
import { CompanySettingsContext } from '../context/CompanySettingsContext'

export default function useCompanySettings() {
  return useContext(CompanySettingsContext)
}
